import keygen from "keygenerator"

export const blogPosts = [
  {
    key: keygen._(),
    title: "Essential Features Every School Management System Will Have",
    to: "/blog/essential-features-every-school-management-system-will-have/",
    date: "13 Apr 2026",
    footnote: "Published on 13 Apr 2026",
    note: "Published on 13 Apr 2026",
    icon: require("~content/blog/images/Essential Features Every School Management System Will Have.jpg"),
    description: "Strong reading habits play a vital role in supporting language accuracy, comprehension, and confidence in Singapore's education system. When reading is aligned with school syllabi and matched to a child's ability, it strengthens classroom readiness and supports steady academic progress over time.",
    child: [],
  },
  {
    key: keygen._(),
    title: "How AI Is Transforming Language Learning",
    to: "/blog/how-ai-is-transforming-language-learning/",
    date: "30 Mar 2026",
    footnote: "Published on 30 Mar 2026",
    note: "Published on 30 Mar 2026",
    icon: require("~content/blog/images/How AI Is Transforming Language Learning.jpg"),
    description: "Strong reading habits play a vital role in supporting language accuracy, comprehension, and confidence in Singapore's education system. When reading is aligned with school syllabi and matched to a child's ability, it strengthens classroom readiness and supports steady academic progress over time.",
    child: [],
  },
  {
    key: keygen._(),
    title: "Why Every School Needs A Student Information System",
    to: "/blog/why-every-school-needs-a-student-information-system/",
    date: "16 Mar 2026",
    footnote: "Published on 16 Mar 2026",
    note: "Published on 16 Mar 2026",
    icon: require("~content/blog/images/Why Every School Needs A Student Information System.jpg"),
    description: "Strong reading habits play a vital role in supporting language accuracy, comprehension, and confidence in Singapore's education system. When reading is aligned with school syllabi and matched to a child's ability, it strengthens classroom readiness and supports steady academic progress over time.",
    child: [],
  },
  {
    key: keygen._(),
    title: "How Reading Habits Shape a Child's Academic Success ",
    to: "/blog/how-reading-habits-shape-a-child/",
    date: "02 Mar 2026",
    footnote: "Published on 02 Mar 2026",
    note: "Published on 02 Mar 2026",
    icon: require("~content/blog/images/How Reading Habits Shape a Child.jpg"),
    description: "Strong reading habits play a vital role in supporting language accuracy, comprehension, and confidence in Singapore's education system. When reading is aligned with school syllabi and matched to a child's ability, it strengthens classroom readiness and supports steady academic progress over time.",
    child: [],
  },
  {
    key: keygen._(),
    title: "How Personalised Learning Platforms Improve Student Outcomes",
    to: "/blog/how-personalised-learning-platform/",
    date: "02 Feb 2026",
    footnote: "Published on 02 Feb 2026",
    note: "Published on 02 Feb 2026",
    icon: require("~content/blog/images/How Personalised Learning Platforms.jpg"),
    description: "Every student approaches language learning differently, progressing at their own pace. Many tools assume uniform readiness, creating gaps in confidence and understanding. In Singapore, DuduTown reinforces school-based Mandarin learning through syllabus alignment, adaptive placement, and structured progression, allowing students to build clarity, confidence, and consistency without losing academic discipline or learning focus over time",
    child: [],
  },
  {
    key: keygen._(),
    title: "Why Listening and Reading Help You Improve in Chinese",
    to: "/blog/why-listening-and-reading/",
    date: "02 Jan 2026",
    footnote: "Published on 02 Jan 2026",
    note: "Published on 02 Jan 2026",
    icon: require("~content/blog/images/Why Listening and Reading.jpg"),
    description: "Many learners focus on speaking when learning Mandarin, yet real progress begins with understanding. Listening and reading build vocabulary, sentence awareness, and meaning before expression. In preschool settings, structured exposure aligned with classroom learning helps children absorb Chinese naturally, retain knowledge, and develop confidence steadily without pressure over time and with consistent guidance from educators.",
    child: [],
  },
  {
    key: keygen._(),
    title: "The Future of Adaptive Learning in Education",
    to: "/blog/the-future-of-adaptive-learning-in-education/",
    date: "20 Dec 2025",
    footnote: "Published on 20 Dec 2025",
    note: "Published on 20 Dec 2025",
    icon: require("~content/blog/images/The Future of Adaptive Learning in Education.jpg"),
    description: "Education is moving towards adaptive learning models that personalise progress while staying aligned with Singapore's school curriculum. By adjusting lessons to each learner's ability, adaptive learning supports mastery, continuity, and confidence, especially in language education, where strong foundations matter. This balanced approach ensures personalisation without sacrificing structure or academic rigour for modern classrooms today nationwide.",
    child: [],
  },
  {
    key: keygen._(),
    title: "How Holistic Development in Early Childhood Is Supported by Chinese Learning Apps",
    to: "/blog/how-holistic-development-in-early-childhood/",
    date: "02 Dec 2025",
    footnote: "Published on 02 Dec 2025",
    note: "Published on 02 Dec 2025",
    icon: require("~content/blog/images/Holistic Development.jpg"),
    description: "Learn how Chinese learning apps designed around school syllabi support holistic development in early childhood through structured, engaging, and age-appropriate Mandarin learning.",
    child: [],
  },
  {
    key: keygen._(),
    title: "How to Improve in Chinese: Effective Tips for Every Learner",
    to: "/blog/how-to-improve-in-chinese/",
    date: "26 Nov 2025",
    footnote: "Published on 26 Nov 2025",
    note: "Published on 26 Nov 2025",
    icon: require("~content/blog/images/How to improve Chinese_1.png"),
    description: "How to Improve in Chinese with practical tips and strategies tailored for every learner. Discover engaging ways to enhance your language skills today!",
    child: [],
  },
  {
    key: keygen._(),
    title: "Why Chinese Picture Books Are Powerful Learning Tools",
    to: "/blog/why-chinese-picture-books-are-powerful-learning-tools/",
    date: "15 Nov 2025",
    footnote: "Published on 15 Nov 2025",
    note: "Published on 15 Nov 2025",
    icon: require("~content/blog/images/Why Chinese Picture Books Are Powerful Learning Tools.png"),
    description: "Picture books aren't just for children. They're powerful tools for language learners at all levels. They simplify vocabulary, provide context, and introduce culture in an easy-to-digest way. For beginners, pictures bridge the gap between words and meaning.",
    child: [],
  },
  {
    key: keygen._(),
    title: "Fun Ways to Learn Mandarin for Kids and Adults",
    to: "/blog/fun-ways-to-learn-mandarin/",
    date: "26 Oct 2025",
    footnote: "Published on 26 Oct 2025",
    note: "Published on 26 Oct 2025",
    icon: require("~content/blog/images/Learn Chinese Effectively.jpg"),
    description: "Discover fun ways to learn Mandarin for kids and adults, making language learning enjoyable and effective for everyone.",
    child: [],
  },
  {
    key: keygen._(),
    title: "Effective Ways to Learn Chinese in Today's Digital Age",
    to: "/blog/effective-ways-to-learn-chinese/",
    date: "26 Sept 2025",
    footnote: "Published on 26 Sept 2025",
    note: "Published on 26 Sept 2025",
    icon: require("~content/blog/images/Effective Ways to Learn Chinese-01.jpg"),
    description: "Effective Ways to Learn Chinese in today's digital age include leveraging technology, immersive experiences, and structured learning to enhance your language skills.",
    child: [],
  },
  {
    key: keygen._(),
    title: "How to Learn Mandarin Fast: Practical Tips that Actually Work",
    to: "/blog/how-to-learn-mandarin-fast/",
    date: "26 Aug 2025",
    footnote: "Published on 26 Aug 2025",
    note: "Published on 26 Aug 2025",
    icon: require("~content/blog/images/Learn Chinese Fast.jpg"),
    description: "How to learn Mandarin fast? Discover practical tips and strategies to accelerate your Mandarin learning journey and connect with Chinese culture.",
    child: [],
  },
]

// Derived array for the sidebar accordion (allItems shape)
export const allItems = blogPosts.map(({ title, footnote, to, child, date }) => ({
  title,
  footnote,
  to,
  child,
  date,
}))

// Derived array for the landing page cards (points shape)
export const points = blogPosts.map(({ key, icon, title, to, description, note }) => ({
  key,
  icon,
  title,
  to,
  description,
  note,
}))